import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";
import { companyInfo, products as localProducts } from "@/data/products";
import { apiClient } from "@/lib/api";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [products, setProducts] = useState(localProducts);
  const [company, setCompany] = useState(companyInfo);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsResponse, companyResponse] = await Promise.all([
          apiClient.get("/products"),
          apiClient.get("/company-info"),
        ]);
        setProducts(productsResponse.data || localProducts);
        setCompany({ ...companyInfo, ...companyResponse.data });
      } catch (error) {
        console.warn("Using local fallback data", error?.message);
      }
    };
    fetchData();
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-slate-50">
        <SiteHeader company={company} />
        <main>
          <ScrollToTop />

          <Routes>
            <Route path="/" element={<HomePage company={company} products={products} />} />
            <Route path="/products" element={<ProductsPage products={products} />} />
            <Route path="/contact" element={<ContactPage company={company} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

        </main>
        <SiteFooter company={company} />
        <Toaster position="top-right" richColors data-testid="app-toaster" />
      </div>
    </BrowserRouter>
  );
}

export default App;
